import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import "./index.css";

type PropsType = {
    children: React.ReactNode;
    setIsConfigurationModalOpened: (value: boolean) => void;
    isConfigurationModalOpened: boolean;
    onSave?: () => void;
    isLoading?: boolean;
};

export function ModalWrapper({
    children,
    setIsConfigurationModalOpened,
    isConfigurationModalOpened,
    onSave,
    isLoading = false,
}: PropsType): JSX.Element {
    const { t } = useTranslation();

    const handleClose = () => {
        setIsConfigurationModalOpened(false);
    };

    const handleSave = () => {
        if (onSave) {
            onSave();
        } else {
            handleClose();
        }
    };

    return (
        <React.Fragment>
            <Modal
                data-testid="scan-to-modal-wrapper"
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={isConfigurationModalOpened}
                className="scan-to-modal-wrapper__clz"
            >
                <ModalHeader
                    data-testid="scan-to-modal-wrapper-header"
                    toggle={handleClose}
                    className="text-uppercase"
                >
                    {t("Scan to Start Configuration")}
                </ModalHeader>
                <ModalBody className="p-0">{children}</ModalBody>
                <ModalFooter>
                    <CustomMainColorButton
                        data-testid="scan-to-modal-wrapper-save-btn"
                        className="w-20 scan-to_btn_save"
                        rounded
                        variant="primary"
                        onClick={handleSave}
                        disabled={isLoading}
                    >
                        {t("Save")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
